var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiService } from "./api.service";
import { v4 as uuidv4 } from 'uuid';
var SessionService = /** @class */ (function (_super) {
    __extends(SessionService, _super);
    function SessionService(botId) {
        var _this = this;
        var resolvedBotId = botId || process.env.AIGO_BOT_ID || process.env.VITE_AIGO_BOT_ID;
        var clientId = process.env.AIGO_CLIENT_ID || process.env.VITE_AIGO_CLIENT_ID;
        var userStorageKey = "aigo-user-id-".concat(resolvedBotId);
        var sessionStorageKey = "aigo-session-id-".concat(resolvedBotId);
        var userId = localStorage.getItem(userStorageKey);
        var sessionId = sessionStorage.getItem(sessionStorageKey);
        if (!userId) {
            userId = uuidv4();
            localStorage.setItem(userStorageKey, userId);
        }
        if (!sessionId) {
            sessionId = uuidv4();
            sessionStorage.setItem(sessionStorageKey, sessionId);
        }
        var client = {
            botId: resolvedBotId,
            clientId: clientId,
            sessionId: sessionId,
            userId: userId,
        };
        _this = _super.call(this, client) || this;
        _this.startNewChat = function () {
            var sessionStorageKey = "aigo-session-id-".concat(_this.client.botId);
            var newSessionId = uuidv4();
            _this.client.sessionId = newSessionId;
            sessionStorage.setItem(sessionStorageKey, newSessionId);
            _this.resetMessageOrderId();
        };
        return _this;
    }
    return SessionService;
}(ApiService));
export { SessionService };
